import React, { useState } from "react";
import userImg from "../../../../img/DynamicSoftware.png";

import {
  IoCallOutline,
  IoBusinessOutline,
} from "react-icons/io5";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import AttandenceTable from "../../../../components/Tables/AttandenceTable";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";
export default function Attendance({ employeeName }) {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const [hoverIndex, setHoverIndex] = useState(null);

  const { EmployeeAttendancedata, EmployeeProfile1data } = useSelector(
    (state) => state.PayRollSlice,
  );
  const getRows = EmployeeAttendancedata?.Data?.map((label, index) => ({
    id: index + 1,
    MONTHNAME: label.MONTHNAME,
    Day1: label.Day1,
    Day2: label.Day2,
    Day3: label.Day3,
    Day4: label.Day4,
    Day5: label.Day5,
    Day6: label.Day6,
    Day7: label.Day7,
    Day8: label.Day8,
    Day9: label.Day9,
    Day10: label.Day10,
    Day11: label.Day11,
    Day12: label.Day12,
    Day13: label.Day13,
    Day14: label.Day14,
    Day15: label.Day15,
    Day16: label.Day16,
    Day17: label.Day17,
    Day18: label.Day18,
    Day19: label.Day19,
    Day20: label.Day20,
    Day21: label.Day21,
    Day22: label.Day22,
    Day23: label.Day23,
    Day24: label.Day24,
    Day25: label.Day25,
    Day26: label.Day26,
    Day27: label.Day27,
    Day28: label.Day28,
    Day29: label.Day29,
    Day30: label.Day30,
    Day31: label.Day31,
    TotPresent: label.TotPresent,
    TotalAbsent: label.TotalAbsent,
    TotHoliday: label.TotHoliday,
    TotWklyOff: label.TotWklyOff,
    TotLeave: label.TotLeave,
  }));

  const getColumns = [
    { key: "id", label: "ID", align: "center" },
    { key: "TotPresent", label: "Present", align: "right" },
    { key: "TotalAbsent", label: "Absent", align: "right" },
    { key: "TotHoliday", label: "Holiday", align: "right" },
    { key: "TotWklyOff", label: "Weekly Off", align: "right" },
    { key: "TotLeave", label: "Leave", align: "right" },
    { key: "MONTHNAME", label: "Month", align: "left" },
    ...Array.from({ length: 31 }, (_, i) => ({
      key: `Day${i + 1}`,
      label: `${i + 1}`,
      align: "right",
    })),
  ];
  const dummyData = {
    EmplName: EmployeeProfile1data?.Data?.[0]?.EmplName,
    EmplExperience: EmployeeProfile1data?.Data?.[0]?.EmplExperience,
    Deptname: EmployeeProfile1data?.Data?.[0]?.Deptname,
    Designation: EmployeeProfile1data?.Data?.[0]?.Designation,
    DateOfBirth: EmployeeProfile1data?.Data?.[0]?.DateOfBirth,
    JoiningDate: EmployeeProfile1data?.Data?.[0]?.JoiningDate,
    BloodGroup: EmployeeProfile1data?.Data?.[0]?.BloodGroup,
    MobileNo: EmployeeProfile1data?.Data?.[0]?.MobileNo,
    BankName: EmployeeProfile1data?.Data?.[0]?.BankName,
    PfNo: EmployeeProfile1data?.Data?.[0]?.PfNo,
    UanNo: EmployeeProfile1data?.Data?.[0]?.UanNo,
    ESINo: EmployeeProfile1data?.Data?.[0]?.ESINo,
    AdharNo: EmployeeProfile1data?.Data?.[0]?.AdharNo,
    EmergencyNo: EmployeeProfile1data?.Data?.[0]?.EmergencyNo,
    BankAc: EmployeeProfile1data?.Data?.[0]?.BankAc,
    Photo64: EmployeeProfile1data?.Data?.[0]?.Photo,
  };

  const getValue = (val) => val || "-";
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };
  const boxData = [
    {
      label: "Employee Name",
      value: getValue(dummyData?.EmplName),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Designation",
      value: getValue(dummyData?.Designation),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Date Of Birth",
      value: formatDate(dummyData?.DateOfBirth),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Joining Date",
      value: formatDate(dummyData?.JoiningDate),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Blood Group",
      value: getValue(dummyData?.BloodGroup),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Mobile",
      value: getValue(dummyData?.MobileNo),
      icon: <IoCallOutline />,
    },
    {
      label: "Emergency",
      value: getValue(dummyData?.EmergencyNo),
      icon: <IoCallOutline />,
    },
    {
      label: "Bank",
      value: getValue(dummyData?.BankName),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Account No",
      value: getValue(dummyData?.BankAc),
      icon: <IoBusinessOutline />,
    },
    {
      label: "UAN",
      value: getValue(dummyData?.UanNo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "PF",
      value: getValue(dummyData?.PfNo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "ESI",
      value: getValue(dummyData?.ESINo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Aadhar",
      value: getValue(dummyData?.AdharNo),
      icon: <IoBusinessOutline />,
    },
  ];
  if (!employeeName || employeeName.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          fontSize: "18px",
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour10,
        }}
      >
        Please Select Employee Name
      </div>
    );
  }
  // ✅ Loader check
  if (EmployeeAttendancedata === "no" || EmployeeAttendancedata === null) {
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        marginTop: "15px",
        borderRadius: "12px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
      }}
    >
      <Row>
        <Col>
          <div
            style={{
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10
              }`,
              borderRadius: "10px",
              overflow: "hidden",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
            }}
          >
            <div
              style={{
                padding: "20px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderBottom: `1px solid ${
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10
                }`,
              }}
            >
              <Row className="align-items-center">
                <Col xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* IMAGE */}
                    <img
                      src={userImg}
                      alt="Customer"
                      style={{
                        width: "95px",
                        height: "95px",
                        borderRadius: "20px",
                        border: `2px solid ${
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                        }`,
                      }}
                    />

                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* 🔥 LEFT SIDE (NEW DATA ADD) */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                          }}
                        >
                          {/* Department Name */}
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour10
                                  : iscolourDark?.Colour10,
                            }}
                          >
                            {dummyData.Deptname}
                          </div>

                          {/* Experience */}
                          <div
                            style={{
                              fontSize: "13px",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour10
                                  : iscolourDark?.Colour10,
                            }}
                          >
                            Experience: {dummyData.EmplExperience}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* 🔽 BOTTOM SECTION */}
            <div style={{ padding: "12px" }}>
              <Row className="g-2">
                {boxData.map((item, i) => (
                  <Col xl={4} lg={4} md={6} sm={6} xs={12} ke={i}>
                    <div
                      onMouseEnter={() => setHoverIndex(i)}
                      onMouseLeave={() => setHoverIndex(null)}
                      style={{
                        border: `1px solid ${
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                        }`,
                        borderRadius: "8px",
                        padding: "10px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        background:
                          hoverIndex === i
                            ? isdark === "light"
                              ? iscolour?.Colour2
                              : iscolourDark?.Colour4
                            : isdark === "light"
                              ? iscolour?.Colour1
                              : iscolourDark?.Colour2,
                      }}
                    >
                      <div
                        style={{
                          fontSize: "18px",
                          minWidth: "24px",
                          display: "flex",
                          justifyContent: "center",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour10,
                          background:
                            isdark === "light"
                              ? iscolour?.Colour3
                              : iscolourDark?.Colour3,
                          padding: "8px",
                          borderRadius: "6px",
                        }}
                      >
                        {item.icon}
                      </div>

                      <div style={{ flex: 1, overflow: "hidden" }}>
                        <div
                          style={{
                            fontSize: "14px",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour6
                                : iscolourDark?.Colour10,
                          }}
                        >
                          {item.label}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour10
                                : iscolourDark?.Colour10,
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          <div
            style={{
              marginTop: "25px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              EMPLOYEE ATTANDANCE
            </div>

            <AttandenceTable
              columns={getColumns}
              data={getRows}
              showSearch={true}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
